import * as RadixContextMenu from '@radix-ui/react-context-menu';
import {
  StyledCheckboxItem,
  StyledContent,
  StyledItem,
  StyledItemIndicator,
  StyledSeparator,
  StyledSubContent,
  StyledSubTrigger,
} from './context-menu.styled';

export const ContextMenu = {
  ...RadixContextMenu,
  Content: StyledContent,
  SubTrigger: StyledSubTrigger,
  SubContent: StyledSubContent,
  CheckboxItem: StyledCheckboxItem,
  ItemIndicator: StyledItemIndicator,
  Item: StyledItem,
  Separator: StyledSeparator,
};
